import LinearProgress from "@material-ui/core/LinearProgress";
import { makeStyles } from "@material-ui/core/styles";
import React from "react";
import StyledTooltip from "../../../../../components/Wrapper/StyledTooltip";
import { tesaGrey4 } from "../../../../../styles/colors";

const useStyles = makeStyles(() => ({
  progressBar: {
    width: "40px",
    height: "20px",
    backgroundColor: tesaGrey4,
  },
}));

interface ProgressBarProps {
  completed: number;
  total: number;
}

const ProgressBar: React.FC<ProgressBarProps> = (props) => {
  const { completed, total } = props;
  const classes = useStyles();
  const progress = total ? ((completed ?? 0) / total) * 100 : 0;

  return (
    <StyledTooltip title={`${completed ?? 0}/${total ?? 0}`}>
      <LinearProgress className={classes.progressBar} value={progress} variant="determinate" />
    </StyledTooltip>
  );
};

export default ProgressBar;
